module.exports = __webpack_public_path__ + "img/GB-WhatsApp-for-pc.bbfb018b.webp";